import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  BasicSignaturePayload,
  IJwtWeb3VerifyDto,
  ILoginDto,
  ILoginResponseDto,
} from '@nft-folks/interfaces';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  constructor(private apiService: ApiService) {}

  login(credentials: ILoginDto): Observable<ILoginResponseDto> {
    return this.apiService.post('/login', credentials);
  }

  logout(): Observable<void> {
    return this.apiService.get('/logout');
  }

  verify(idToken: string, payload: IJwtWeb3VerifyDto): Observable<ILoginResponseDto> {
    return this.apiService.post('/verify', payload, {
      headers: {
        Authorization: `Bearer ${idToken}`,
        'Content-Type': 'application/json',
      },
    });
  }

  verifyBasic(payload: BasicSignaturePayload): Observable<ILoginResponseDto> {
    return this.apiService.post('/verify-basic', payload);
  }
}
